import {
  animate,
  keyframes,
  query,
  stagger,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NewsItem } from 'src/app/models/getNews.model';
import { BaseServicesService } from 'src/app/services/base-services/base-services.service';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { SafeHtmlize } from 'src/app/layouts/pipe/htmlize/safe-html.pipe';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Location } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { LoggingService } from 'src/app/services/consoleLogs';
import { SkeletonModule } from 'primeng/skeleton';
@Component({
  selector: 'app-newspage',
  standalone: true,
  imports: [CarouselModule, CommonModule,ButtonModule,SkeletonModule],
  templateUrl: './newspage.component.html',
  styleUrl: './newspage.component.scss',
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('1.2s ease', style({ opacity: 1 })),
      ]),
    ]),
    trigger('parallaxSlide', [
      transition(':enter', [
        style({ transform: 'translateY(40px) scale(0.98)', opacity: 0 }),
        animate(
          '1s 0.3s cubic-bezier(0.33, 1, 0.68, 1)',
          style({ transform: 'translateY(0) scale(1)', opacity: 1 })
        ),
      ]),
    ]),
    trigger('zoomInOut', [
      transition(':enter', [
        style({ transform: 'scale(1.1)', opacity: 0 }),
        animate(
          '1.2s cubic-bezier(0.4, 0, 0.2, 1)',
          style({ transform: 'scale(1)', opacity: 1 })
        ),
      ]),
    ]),
    trigger('staggerPop', [
      transition(':enter', [
        query('.article-title, .meta-badge', [
          style({ opacity: 0, transform: 'translateY(20px)' }),
          stagger(200, [
            animate(
              '0.6s cubic-bezier(0.34, 1.56, 0.64, 1)',
              style({ opacity: 1, transform: 'translateY(0)' })
            ),
          ]),
        ]),
      ]),
    ]),
    trigger('flipIn', [
      transition(':enter', [
        style({ transform: 'rotateX(90deg) scale(0.5)', opacity: 0 }),
        animate(
          '0.8s cubic-bezier(0.34, 1.56, 0.64, 1)',
          style({ transform: 'rotateX(0) scale(1)', opacity: 1 })
        ),
      ]),
    ]),
    trigger('fadeSlide', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(-40px)' }),
        animate(
          '0.8s 0.2s ease-out',
          style({ opacity: 1, transform: 'translateX(0)' })
        ),
      ]),
    ]),
    trigger('carouselSwipe', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(100px)' }),
        animate(
          '0.6s cubic-bezier(0.22, 1, 0.36, 1)',
          style({ opacity: 1, transform: 'translateX(0)' })
        ),
      ]),
      transition(':leave', [
        animate(
          '0.6s cubic-bezier(0.22, 1, 0.36, 1)',
          style({ opacity: 0, transform: 'translateX(-100px)' })
        ),
      ]),
    
    ]),
    trigger('textGlow', [
      transition(':enter', [
        style({ textShadow: '0 0 0px #fff' }),
        animate('1s ease-out', style({ textShadow: '0 0 8px #00f' }))
      ])
    ]),
    trigger('riseUp', [
      transition(':enter', [
        style({ transform: 'translateY(20px)', opacity: 0 }),
        animate('600ms ease-out', style({ transform: 'translateY(0)', opacity: 1 }))
      ])
    ]),
    trigger('floatAnimation', [
      state('normal', style({
        transform: 'translateY(0)'
      })),
      state('hover', style({
        transform: 'translateY(-5px)',
        boxShadow: '0 10px 20px rgba(0,0,0,0.2)'
      })),
      transition('normal => hover', animate('200ms ease-in')),
      transition('hover => normal', animate('200ms ease-out'))
    ]),
    trigger('clickAnimation', [
      state('default', style({
        transform: 'scale(1)'
      })),
      state('clicked', style({
        transform: 'scale(0.9)'
      })),
      transition('default => clicked', animate('100ms ease-in')),
      transition('clicked => default', animate('100ms ease-out'))
    ]),
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ]),
    trigger('buttonAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate(
          '300ms 100ms ease-out',
          style({ opacity: 1, transform: 'translateY(0)' })
        ),
      ]),
    ]),
    trigger('overlayAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-out', style({ opacity: 1 })),
      ]),
      transition(':leave', [animate('200ms ease-in', style({ opacity: 0 }))]),
    ]),
    trigger('dialogAnimation', [
      transition('void => *', [
        style({ transform: 'scale(0.8) translateY(-40px)', opacity: 0 }),
        animate(
          '300ms cubic-bezier(0.4, 0, 0.2, 1)',
          style({ transform: 'scale(1) translateY(0)', opacity: 1 })
        ),
      ]),
      transition('* => void', [
        animate(
          '200ms cubic-bezier(0.4, 0, 0.2, 1)',
          style({ transform: 'scale(0.8) translateY(40px)', opacity: 0 })
        ),
      ]),
     
    ]),
    trigger('iconAnimation', [
      transition('* => success', [
        animate('0.5s', keyframes([
          style({ transform: 'scale(1)', offset: 0 }),
          style({ transform: 'scale(1.2)', offset: 0.5 }),
          style({ transform: 'scale(1)', offset: 1 })
        ]))
      ])
    ])
    
  ],
})
export class NewspageComponent implements OnInit {
  newsId: string | null = null;
  newsData: NewsItem | null = null;
  published!:boolean;
  autoScrollInterval: any;
  showPublishDialog = false;
  dialogState: 'void' | 'show' = 'show';
  sanitizedContent!: SafeHtml;
  publishState: 'idle' | 'processing' | 'success' = 'idle';
  errorMessage: string = '';

  activeIndex = 0;
  constructor(
    private route: ActivatedRoute,
    private newsService: BaseServicesService, // Inject the NewsService,
    private sanitizer: DomSanitizer,
    private location: Location,
    private baseService : BaseServicesService,
    private loggingService : LoggingService
  ) {}

  ngOnInit(): void {
    this.loggingService.log('logginf');
    this.newsId = this.route.snapshot.paramMap.get('newsId');
    this.published = this.route.snapshot.queryParamMap.get('published') === 'true';
    if (this.newsId) {
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      this.newsService.getNewsById(this.newsId, timeZone).subscribe({
        next: (res: NewsItem) => {
          this.newsData = res;
          this.loggingService.log(
            "this.newsData",this.newsData
          )
          this.sanitizedContent = this.sanitizer.bypassSecurityTrustHtml(this.newsData?.details?.newsContent);


        },
        error: (err) => {
          this.loggingService.error('Error fetching news:', err);
        },
      });
    }
    this.startAutoScroll();
   
  }
  updateEditStatus(id: string) {
    this.loggingService.log('id===>:', id);
    this.baseService.updateEditStatus(id).subscribe({
      next: (res) => {
        this.loggingService.log('Newa id from new Compponent', res);
      },
      error: (err) => {
        this.loggingService.error('Error updating status', err);
      }
    });
    
  }
  ngOnDestroy(): void {
    this.clearAutoScroll(); // Clean up on destroy
  }
  startAutoScroll(): void {
    this.autoScrollInterval = setInterval(() => {
      this.nextSlide();
    }, 3000); // Auto-scroll every 3 seconds
  }
  
  clearAutoScroll(): void {
    if (this.autoScrollInterval) {
      clearInterval(this.autoScrollInterval);
    }
  }
  
  nextSlide(): void {
    if (this.newsData?.newsImages?.length) {
      this.activeIndex = (this.activeIndex + 1) % this.newsData.newsImages.length;
    }
  }
  
  prevSlide(): void {
    if (this.newsData?.newsImages?.length) {
      this.activeIndex =
        (this.activeIndex - 1 + this.newsData.newsImages.length) %
        this.newsData.newsImages.length;
    }
  }
  
  setActiveIndex(index: number): void {
    this.activeIndex = index;
    this.clearAutoScroll();   // optional: stop auto-scroll when manually selected
    this.startAutoScroll();   // optional: restart auto-scroll
  }
  goBack(): void {
    this.location.back();
  }
  buttonState = 'normal';
  clickState = 'default';

  @HostListener('mouseenter')
  onMouseEnter() {
    this.buttonState = 'hover';
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.buttonState = 'normal';
  }

  animateClick() {
    this.clickState = 'clicked';
    setTimeout(() => {
      this.clickState = 'default';
    }, 100);
  }
  publish() {
    this.animateClick();
  
    this.loggingService.log('Publishing...', this.newsId);
   
    this.showPublishDialog = true
  }
  cancelPublish() {
    this.publishState = 'idle';
    this.showPublishDialog = false;
  }
  
  confirmPublish() {
    this.publishState = 'processing';
    this.errorMessage = '';
  
    this.newsService.updateNewsStatus(this.newsId!, 'publish').subscribe({
      next: (response) => {
        this.publishState = 'success';
        this.loggingService.log('Publish success:', response);
        this.published = true; 
        setTimeout(() => {
          this.showPublishDialog = false;
          this.publishState = 'idle';
          this.errorMessage = '';
        }, 2000);
      },
      error: (error) => {
        this.loggingService.error('Publish failed:', error);
        this.publishState = 'idle';
        this.errorMessage = error?.error?.message || 'An error occurred while publishing.';
      }
    });
  }
    
  
}
